import React from 'react';
import { Navigate, useParams } from 'react-router';
import { useLeague } from '../hooks/useLeague';
import LoadingState from './LoadingState';
import { lscPath } from '../routing';

export const COMMISSIONER_ONLY_REDIRECT_STATE = 'commissionerNotice' as const;

/** Redirect non-commissioners away from commissioner-only routes before data loads. */
const CommissionerOnlyGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { leagueId } = useParams<{ leagueId: string }>();
  const { isOperator, loading } = useLeague();

  if (loading) {
    return <LoadingState message="Loading league workspace..." />;
  }

  if (!isOperator) {
    return (
      <Navigate
        to={lscPath(`/leagues/${leagueId}`)}
        replace
        state={{ [COMMISSIONER_ONLY_REDIRECT_STATE]: true }}
      />
    );
  }

  return <>{children}</>;
};

export default CommissionerOnlyGate;
